import { buildRoute } from '@direct-frontend/modules-router';

export const filtersRootRoute = buildRoute('/filters');

export const filtersCommonRoute = buildRoute('/filters/common');

export type FiltersCategoryParams = {
    categoryId: string;
};
export const filtersCategoryRoute = buildRoute<FiltersCategoryParams>('/filters/category/:categoryId');
export type FiltersCollectionParams = {
    collectionId: string;
};
export const filtersCollectionRoute = buildRoute<FiltersCollectionParams>('/filters/collection/:collectionId');
export const filtersCollectionAutoRoute = buildRoute<FiltersCollectionParams>('/filters/collection-auto/:collectionId');
